import { FeeInterface as FeeProto } from '@vendasta/billing';

export interface Fee {
  amount?: number;
  amountType?: FeeAmountType;
  feeType?: FeeType;
}

export enum FeeAmountType {
  FEE_AMOUNT_TYPE_INVALID = 0,
  FEE_AMOUNT_TYPE_FIXED = 1,
  FEE_AMOUNT_TYPE_PERCENTAGE = 2,
}

export enum FeeType {
  FEE_TYPE_INVALID = 0,
  FEE_TYPE_MANAGEMENT = 1,
}

export function feesFromApi(protos: FeeProto[]): Fee[] {
  if (!protos || protos.length < 1) {
    return [];
  }
  return protos.map((proto) => {
    return {
      amount: proto.amount || 0,
      amountType: proto.amountType,
      feeType: proto.feeType,
    };
  });
}

export function feesToApi(fees: Fee[]): FeeProto[] {
  if (!fees || fees.length < 1) {
    return [];
  }
  return fees.map((fee) => {
    return {
      amount: fee.amount || 0,
      amountType: fee.amountType,
      feeType: fee.feeType,
    };
  });
}
